// Removes quotes wrapping fields and sets them to lower case to match the field names in the backend.
export const desanitizeField = (field: string): string => {
	if (
		(field.startsWith('"') && field.endsWith('"')) ||
		(field.startsWith("'") && field.endsWith("'"))
	) {
		return field.slice(1, -1).toLocaleLowerCase();
	}
	return field.toLocaleLowerCase();
};
